export {
  computeProductPrice,
  extractProductBrands,
  formatOptionLabel,
  formatFacetOptionLabel,
  isDiscreteFacetKey,
  sanitizeOptionValue,
  toLooseNumber,
} from './productFilters.shared'
export { buildSearchFacets } from './productFilters.facets'
export { countActiveSearchFilters, filterSearchProducts } from './productFilters.matching'
